module.exports = __webpack_public_path__ + "static/media/Lens-NS_TW.56dc2a7e.png";